var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.52827 3.52861C3.78862 3.26826 4.21073 3.26826 4.47108 3.52861L7.99967 7.0572L11.5283 3.52861C11.7886 3.26826 12.2107 3.26826 12.4711 3.52861C12.7314 3.78896 12.7314 4.21107 12.4711 4.47141L8.94248 8.00001L12.4711 11.5286C12.7314 11.789 12.7314 12.2111 12.4711 12.4714C12.2107 12.7318 11.7886 12.7318 11.5283 12.4714L7.99967 8.94282L4.47108 12.4714C4.21073 12.7318 3.78862 12.7318 3.52827 12.4714C3.26792 12.2111 3.26792 11.789 3.52827 11.5286L7.05687 8.00001L3.52827 4.47141C3.26792 4.21107 3.26792 3.78896 3.52827 3.52861Z",
    fill: "#02BF8E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseGreen);
export default __webpack_public_path__ + "static/media/close_green.dad24b5c.svg";
export { ForwardRef as ReactComponent };